import { HRRecall, JobApplication } from '../../../providers/api/dtos';
import { formatInputDate, formatInputTime, formDateTimeToDate } from '../../../utils/form';
import { HRRecallFormModel } from './HRRecallForm';

export const hrRecallToHRRecallFormModel = (
  hrRecall: HRRecall,
  jobApplication: JobApplication,
  fallback?: Pick<HRRecallFormModel, 'supervisorEmail'>,
): HRRecallFormModel => ({
  supervisorEmail: jobApplication.supervisorEmail || fallback?.supervisorEmail || '',
  date: formatInputDate(new Date(hrRecall.date)),
  time: formatInputTime(new Date(hrRecall.date)),
  note: hrRecall.note || '',
});

export const hrRecallFormModelToHRRecall = (
  formValues: HRRecallFormModel,
  jobApplication: JobApplication,
  hrRecall?: HRRecall,
): HRRecall => ({
  ...hrRecall,
  jobApplicationId: jobApplication.id!,
  date: formDateTimeToDate(formValues.date, formValues.time).toISOString(),
  type: 'RECALL',
  isResolved: hrRecall?.isResolved ?? false,
  note: formValues.note.trim(),
});
